import styles from '../styles/footer.module.css';

import { SocialIcon } from 'react-social-icons';

const Footer = () => {
    return (
        <div className={styles.footer}>
            <div className={styles.socials}>
                <div className={styles.twitter}>
                    <SocialIcon url="https://www.twitter.com/getjaas" bgColor="#000" fgColor="#fff" />
                </div>
                <div className={styles.facebook}>
                    <SocialIcon url="https://www.facebook.com/getjaas" bgColor="#000" fgColor="#fff" />
                </div>
                <div className={styles.email}>
                    <SocialIcon url="mailto:hello@getjaas.com" bgColor="#000" fgColor="#fff" />
                </div>
            </div>
            
            <p className={styles.footerCopyright}>
                &copy; 2022, Powered by JAAS - All rights reserved.
            </p>
        </div>
    );
}
 
export default Footer;